import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateUserNewsletterSlice = getBulkActionSlice(
    'updateUserNewsletterResult',
);

export const selectUpdateNewslettersShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.newsletterUpdateResult.shown;

export const selectUpdateNewslettersBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.newsletterUpdateResult.uuid;

export const selectUpdateNewslettersTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.newsletterUpdateResult.backgroundTask;


export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = updateUserNewsletterSlice.actions;
